module.exports = __webpack_public_path__ + "img/h4b_logo_big.10821bb7.png";